class BranchForm {
    constructor() {
        this.show();
    }
    show(){
        const thisClass = this;
        new ModalLoading();
        naja.makeRequest('GET', '?do=getAddBranchComponent', {
            'organizationID': new URLSearchParams(window.location.search).get('organizationID')
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response) {
                thisClass.events();
                thisClass.changeAvatar();
                thisClass.validation();
                $('.ki-question-2').popover({
                    html: true
                });

                new ModalLoading(document.getElementById('create_branch_modal'));
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    changeAvatar(){
        $('.edit-branch-icon-btn').click(function (){
            new bootstrap.Modal(document.getElementById('change_branch_icon_modal'), {}).show();
            $('.branch-select-icon').click(function () {
                let val = $(this).attr('value');
                $('#add-branch-icon').attr('src','/media/goodaccess/icons/branch/'+val+'.svg');
                $('#change_branch_icon_modal').modal('hide');
                $('#frm-branchForm-branchForm input[name=icon_id]').val(val);
            });
        });
    }
    events(){
        const thisClass = this;
        this.preselectSelect();
        $('#frm-branchForm-branchForm select').select2({
            dropdownParent: $('#create_branch_modal')
        });

        $("#frm-branchForm-branchForm  select[name=pseudo_random_function]").select2({
            placeholder: "",
            dropdownParent: $('#create_branch_modal'),
            allowClear: true
        });

        $("#frm-branchForm-branchForm  select[name=start_action]").select2({
            placeholder: "",
            dropdownParent: $('#create_branch_modal'),
            allowClear: true
        });

        $("#frm-branchForm-branchForm  select[name=vpnServerSelect]").change(function () {
            $('#selectedGwSubnet').text(
                $('#frm-branchForm-branchForm  select[name=vpnServerSelect] option:selected').attr('private-subnet')
            );
        });

        $('#frm-branchForm-branchForm input[name=protocol]').change(function (){
            if($(this).val() == 2){
                new DismissModal('create_branch_modal').enable();
                $('#ipsec-settings-wrapper').addClass('d-none');
                thisClass.removeExtraFieldValidation();
            }
            if ($(this).val() == 3){
                new DismissModal('create_branch_modal').disable(true);
                $('#ipsec-settings-wrapper').removeClass('d-none');
                $("#frm-branchForm-branchForm  select[name=pseudo_random_function]").focus();
                thisClass.addExtraFieldValidation();
            }
        });
        var optionFormat = function(item) {
            if ( !item.id ) {
                return item.text;
            }

            var span = document.createElement('span');
            var imgUrl = item.element.getAttribute('data-kt-select2-country');
            var template = '';

            template += '<img src="' + imgUrl + '" class="h-20px me-4" alt="image" style="border-radius: 4px"/>';
            template += item.text;

            span.innerHTML = template;

            return $(span);
        }
        $('#kt_docs_select2_country').select2({
            templateSelection: optionFormat,
            templateResult: optionFormat,
            dropdownParent: $('#create_branch_modal')
        });
    }
    preselectSelect(){
        $('#frm-branchForm-branchForm select[name=presetSelect]').change(function (e){
            let preset = $(e.target).find(":selected");
            $('#frm-branchForm-branchForm input[name=tunnel_lifetime]').val(preset.attr('tunnel-lifetime'));
            $('#frm-branchForm-branchForm input[name=ike_lifetime]').val(preset.attr('ike-lifetime'));
            $('#frm-branchForm-branchForm input[name=dpdd]').val(preset.attr('dead-peer-detection-delay'));
            $('#frm-branchForm-branchForm select[name=encryption_phase_1]').val(preset.attr('encryption-phase-1')).trigger('change');
            $('#frm-branchForm-branchForm select[name=encryption_phase_2]').val(preset.attr('encryption-phase-2')).trigger('change');
            $('#frm-branchForm-branchForm select[name=integrity_phase_1]').val(preset.attr('integrity-phase-1')).trigger('change');
            $('#frm-branchForm-branchForm select[name=integrity_phase_2]').val(preset.attr('integrity-phase-2')).trigger('change');
            $('#frm-branchForm-branchForm select[name=dh_phase_1]').val(preset.attr('dh-groups-phase-1')).trigger('change');
            $('#frm-branchForm-branchForm select[name=dh_phase_2]').val(preset.attr('dh-groups-phase-2')).trigger('change');
            $('#frm-branchForm-branchForm select[name=start_action]').val(preset.attr('start-action')).trigger('change');
            $('#frm-branchForm-branchForm select[name=pseudo_random_function]').val(preset.attr('pseudo-random-function')).trigger('change');
        });
    }
    addExtraFieldValidation(){
        this.fv.enableValidator('shared_secret');
        this.fv.enableValidator('public_ip');
        this.fv.enableValidator('tunnel_lifetime');
        this.fv.enableValidator('ike_lifetime');
        this.fv.enableValidator('dpdd');
        this.fv.enableValidator('encryption_phase_1');
        this.fv.enableValidator('encryption_phase_2');
        this.fv.enableValidator('integrity_phase_1');
        this.fv.enableValidator('integrity_phase_2');
        this.fv.enableValidator('dh_phase_1');
        this.fv.enableValidator('dh_phase_2');
    }
    removeExtraFieldValidation(){
        this.fv.disableValidator('shared_secret');
        this.fv.disableValidator('public_ip');
        this.fv.disableValidator('tunnel_lifetime');
        this.fv.disableValidator('ike_lifetime');
        this.fv.disableValidator('dpdd');
        this.fv.disableValidator('encryption_phase_1');
        this.fv.disableValidator('encryption_phase_2');
        this.fv.disableValidator('integrity_phase_1');
        this.fv.disableValidator('integrity_phase_2');
        this.fv.disableValidator('dh_phase_1');
        this.fv.disableValidator('dh_phase_2');
    }
    validation(){
            const thisClass = this;
            let form = document.getElementById('frm-branchForm-branchForm');
            if(form){
                let formContainer = $(form);
                let submitButtonID = formContainer.find('button[type=submit]')[0].attributes.id.value;
                let submitButton = document.getElementById(submitButtonID);

                this.fv = FormValidation.formValidation(
                    form,
                    {
                        fields: {
                            'BranchName': {
                                validators: {
                                    notEmpty: {
                                        message: 'This field is required',
                                    },
                                    stringLength: {
                                        max: 64,
                                        message: 'Name cannot be over 64 characters',
                                    },
                                    regexp: {
                                        regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                        message: 'Only these special characters are allowed. (_.-)',
                                    },
                                    remote: {
                                        method: 'POST',
                                        url: '/branches/?do=checkUnique',
                                        message: 'This name is already taken.',
                                        data: function () {
                                            return {
                                                organizationId: new URLSearchParams(window.location.search).get('organizationID')
                                            };
                                        },
                                    }
                                }
                            },
                            'BranchSubnet': {
                                validators: {
                                    notEmpty: {
                                        message: 'This field is required',
                                    },
                                    stringLength: {
                                        max: 64,
                                        message: 'Branch subnet cannot be over 64 characters',
                                    },
                                    remote: {
                                        method: 'POST',
                                        url: '/branches/?do=checkCollision',
                                        data: function () {
                                            return {
                                                vpnServer: $('#frm-branchForm-branchForm select[name="vpnServerSelect"]').val(),
                                                organizationId: new URLSearchParams(window.location.search).get('organizationID')
                                            };
                                        },
                                    }
                                }
                            },
                            'shared_secret':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    },
                                    regexp: {
                                        regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                        message: 'Only letters, numbers and special characters _.- are allowed',
                                    },
                                }
                            },
                            'public_ip':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    },
                                    regexp: {
                                        regexp: /^(?!^0\.)(?!^10\.)(?!^100\.6[4-9]\.)(?!^100\.[7-9]\d\.)(?!^100\.1[0-1]\d\.)(?!^100\.12[0-7]\.)(?!^127\.)(?!^169\.254\.)(?!^172\.1[6-9]\.)(?!^172\.2[0-9]\.)(?!^172\.3[0-1]\.)(?!^192\.0\.0\.)(?!^192\.0\.2\.)(?!^192\.88\.99\.)(?!^192\.168\.)(?!^198\.1[8-9]\.)(?!^198\.51\.100\.)(?!^203.0\.113\.)(?!^22[4-9]\.)(?!^23[0-9]\.)(?!^24[0-9]\.)(?!^25[0-5]\.)(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))|(0\.0\.0\.0\/0)$/,
                                        message: 'Only Public IP is allowed',
                                    }
                                }
                            },
                            'tunnel_lifetime':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    },
                                    integer: {
                                        message: 'Value must be a number',
                                    },
                                    between: {
                                        min: 1,
                                        max: 24,
                                        message: 'Tunnel life time can be in range from 1 to 24'
                                    }
                                }
                            },
                            'ike_lifetime':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    },
                                    integer: {
                                        message: 'Value must be a number',
                                    },
                                    between: {
                                        min: 1,
                                        max: 24,
                                        message: 'IKE lifetime can be in range from 1 to 24'
                                    }
                                }
                            },
                            'dpdd':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    },
                                    integer: {
                                        message: 'Value must be a number',
                                    },
                                    between: {
                                        min: 1,
                                        max: 100,
                                        message: 'Dead Peer Detection Delay can be in range from 1 to 100.'
                                    }
                                }
                            },
                            'encryption_phase_1':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'encryption_phase_2':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'integrity_phase_1':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'integrity_phase_2':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'dh_phase_1':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'dh_phase_2':{
                                validators: {
                                    notEmpty: {
                                        enabled: false,
                                        message: 'This field is required',
                                    }
                                }
                            },
                            'remote_id':{
                                validators: {
                                    regexp: {
                                        regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                        message: 'Only these special characters are allowed. (_.-)',
                                    },
                                }
                            },
                            'snat':{
                                validators: {
                                    regexp: {
                                        regexp: /^(10\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|172\.(?:1[6-9]|2[0-9]|3[0-1])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])|192\.168\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.(?:[0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))$/,
                                        message: 'Only private IP is allowed',
                                    },
                                }
                            }
                        },
                        plugins: {
                            trigger: new FormValidation.plugins.Trigger({
                                delay: {
                                    BranchSubnet: 0.5,
                                    BranchName: 0.5
                                },
                            }),
                            autoFocus: new FormValidation.plugins.AutoFocus(),
                            submitButton: new FormValidation.plugins.SubmitButton(),
                            defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                            bootstrap: new FormValidation.plugins.Bootstrap5({
                                rowSelector: '.form-validation-marker',
                                eleInvalidClass: '',
                                eleValidClass: ''
                            }),
                            icon: new FormValidation.plugins.Icon({
                                valid: 'fa fa-check',
                                invalid: 'fa fa-times',
                                validating: 'fa fa-refresh',
                            }),
                        }
                    }
                ).on('core.form.validating', function(event) {
                    new DismissModal('create_branch_modal').disable();
                    // Show loading indication
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    // Disable button to avoid multiple click
                    submitButton.disabled = true;
                }).on('core.form.valid', function(e) {
                    // Submit form
                    form.submit();
                }).on('core.form.invalid', function(event) {
                    new DismissModal('create_branch_modal').enable();
                    // Show loading indication
                    submitButton.setAttribute('data-kt-indicator', 'off');
                    // Disable button to avoid multiple click
                    submitButton.disabled = false;
                });

                const fv = this.fv;
                this.fv.on('core.element.notvalidated', function(e) {
                    if(e.field === 'dpdd' || e.field === 'ike_lifetime' || e.field === 'tunnel_lifetime'){
                        const iconPlugin = fv.getPlugin('icon');
                        const iconElement = iconPlugin && iconPlugin.icons.has(e.element)
                            ? iconPlugin.icons.get(e.element)
                            : null;

                        iconElement && (iconElement.style.display = 'none');
                    }
                });
            }
    }
}
window.BranchForm = BranchForm;